import { format, parseISO } from 'date-fns';
import Questions from './questions';
import { VRuntimeShell } from '@grupoa/components';

const DEFAULT_LOCALE_DATE_FORMAT = 'dd/MM/yyyy - HH:mm';

export default {
  components: {
    Questions,
    VRuntimeShell
  },
  props    : ['content', 'title'],
  computed : {
    sumPoints() {
      return this.content.questions.reduce(function(acc, question) {
        return acc + Number(question.grade);
      }, 0);
    }
  },
  methods: {
    parseDate(date) {
      if (!date) {
        return '';
      }

      let parsedDate;

      if (typeof date === 'string' || date instanceof String) {
        parsedDate = parseISO(date);
      }

      return format(parsedDate, DEFAULT_LOCALE_DATE_FORMAT);
    }
  }
};
